<template lang="pug">
tbody.thead
  tr
    th(v-if="showDateUserPlaceholder")
    th(v-if="walker.sub_show") {{ walker.sub_label }}
    th(v-if="walker.third_show") {{ walker.third_label }}
    th(v-if="walker.fourth_show") {{ walker.fourth_label }}
    th(v-if="tableShowTasks") To-do / Job
    th(v-if="tableShowManualTime") Manual
    th(v-if="tableShowStarted") Started
    th(v-if="tableShowStopped") Stopped
    th(v-if="tableShowDuration") Duration
    th(v-if="tableShowActivity") Activity
    th(v-if="tableShowNotes") Notes
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { getTaskFlavourLabel, getProjectFlavourLabel } from '~/utils/project_flavour';

export default {
  name: 'WorkSessionsReportTableHeader',
  props: {
    showDateUserPlaceholder: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      'walker',
      'tableShowProjects',
      'tableShowTasks',
      'tableShowManualTime',
      'tableShowStarted',
      'tableShowStopped',
      'tableShowDuration',
      'tableShowActivity',
      'tableShowSpent',
      'tableShowNotes',
    ]),
    ...mapState(['organization']),
    projectLabel() {
      return getProjectFlavourLabel(this.organization.project_flavour);
    },
    taskLabel() {
      return getTaskFlavourLabel(this.organization.project_flavour);
    },
  },
};
</script>
